import { jsx as _jsx } from "react/jsx-runtime";
/**
 * @file 函数式打开一个弹窗
 */
import { isFunction } from '@seiue/util';
import { Portal } from '../Portal';
import { Modal } from './Modal';
import { PlainFullScreen } from './PlainFullScreen';
export const openModal = (props) => {
    const modalKey = Portal.add(_jsx(Modal, Object.assign({ visible: true, onCancel: e => {
            if (isFunction(props.onCancel)) {
                props.onCancel(e);
            }
            else {
                Portal.remove(modalKey);
            }
        } }, props), void 0));
    return {
        hide: () => Portal.remove(modalKey),
    };
};
export const openPlainFullModal = (props) => {
    const modalKey = Portal.add(_jsx(PlainFullScreen, Object.assign({ visible: true }, props), void 0));
    return {
        hide: () => Portal.remove(modalKey),
    };
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoib3Blbi5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9Nb2RhbC9vcGVuLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiO0FBQUE7O0dBRUc7QUFDSCxPQUFPLEVBQUUsVUFBVSxFQUFFLE1BQU0sYUFBYSxDQUFBO0FBR3hDLE9BQU8sRUFBRSxNQUFNLEVBQUUsTUFBTSxXQUFXLENBQUE7QUFFbEMsT0FBTyxFQUFjLEtBQUssRUFBRSxNQUFNLFNBQVMsQ0FBQTtBQUMzQyxPQUFPLEVBQUUsZUFBZSxFQUFFLE1BQU0sbUJBQW1CLENBQUE7QUFFbkQsTUFBTSxDQUFDLE1BQU0sU0FBUyxHQUFHLENBQ3ZCLEtBRUMsRUFDRCxFQUFFO0lBQ0YsTUFBTSxRQUFRLEdBQUcsTUFBTSxDQUFDLEdBQUcsQ0FDekIsS0FBQyxLQUFLLGtCQUNKLE9BQU8sRUFBRSxJQUFJLEVBQ2IsUUFBUSxFQUFFLENBQUMsQ0FBQyxFQUFFO1lBQ1osSUFBSSxVQUFVLENBQUMsS0FBSyxDQUFDLFFBQVEsQ0FBQyxFQUFFO2dCQUM5QixLQUFLLENBQUMsUUFBUSxDQUFDLENBQUMsQ0FBQyxDQUFBO2FBQ2xCO2lCQUFNO2dCQUNMLE1BQU0sQ0FBQyxNQUFNLENBQUMsUUFBUSxDQUFDLENBQUE7YUFDeEI7UUFDSCxDQUFDLElBQ0csS0FBSyxVQUNULENBQ0gsQ0FBQTtJQUVELE9BQU87UUFDTCxJQUFJLEVBQUUsR0FBRyxFQUFFLENBQUMsTUFBTSxDQUFDLE1BQU0sQ0FBQyxRQUFRLENBQUM7S0FDcEMsQ0FBQTtBQUNILENBQUMsQ0FBQTtBQUVELE1BQU0sQ0FBQyxNQUFNLGtCQUFrQixHQUFHLENBQUMsS0FJbEMsRUFBRSxFQUFFO0lBQ0gsTUFBTSxRQUFRLEdBQUcsTUFBTSxDQUFDLEdBQUcsQ0FBQyxLQUFDLGVBQWUsa0JBQUMsT0FBTyxFQUFFLElBQUksSUFBTSxLQUFLLFVBQUksQ0FBQyxDQUFBO0lBRTFFLE9BQU87UUFDTCxJQUFJLEVBQUUsR0FBRyxFQUFFLENBQUMsTUFBTSxDQUFDLE1BQU0sQ0FBQyxRQUFRLENBQUM7S0FDcEMsQ0FBQTtBQUNILENBQUMsQ0FBQSJ9